import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';

import Tooltip from '../../Tooltip';
import withComponentName from '../../../decorators/withComponentName';

import Styles from './pricingPlansTableRow.module.scss';

const cx = classNames.bind(Styles);

const PlanItemTableRow = (props) => {
  const {
    isHeader, className = '', column = [], userPlan,
    activePlane,
  } = props;

  const planTableRow = cx(
    'plan_table_row',
    className,
    {
      plan_table_header: isHeader,
      'user-gold-plan': userPlan === 'gold_plan',
      'user-silver-plan': userPlan === 'silver_plan',
      'user-basic-plan': userPlan === 'basic_plan',
    },
    activePlane,
  );

  return (
    <div className={planTableRow}>
      {
        column.map((tableColumn) => (
          <PlanItemTableRowColumn key={tableColumn.id} {...tableColumn} />
        ))
      }
    </div>
  );
};

const PlanItemTableRowColumn = (props) => {
  const {
    text,
    className: columnClassName,
    isCommingSoon,
    isAvailable,
    isNotAvailable,
    hasToolTip,
    tooltipText,
  } = props;

  return (
    <div className={`${Styles.plan_table_column} ${Styles[columnClassName] || ''}`}>
      <div>
        {text || ''}
        {hasToolTip && (
          <span className={Styles.plan_tooltip_holder}>
            <Tooltip className={Styles.plan_tooltip}>{tooltipText}</Tooltip>
          </span>
        )}
      </div>
      {isCommingSoon && <div className={Styles.plan_comming_soon}>Coming Soon</div>}
      {isAvailable && (<FontAwesomeIcon className={Styles.plan_check} icon={faCheck} />)}
      {isNotAvailable && (<FontAwesomeIcon className={Styles.plan_times} icon={faXmark} />)}
    </div>
  );
};

export default withComponentName(PlanItemTableRow);
